import * as moment from "moment";
import * as React from "react";

import IMessageTotalsByMonthResponse from "../../types/IMessageTotalsByMonthResponse";

import { ITranslationProps, translateComponent } from "../../helpers/translation";

interface IMessageTotalsByMonthTableProps extends ITranslationProps {
    messageTotals: IMessageTotalsByMonthResponse[]
}

class MessageTotalsByMonthTable extends React.Component<IMessageTotalsByMonthTableProps> {

    constructor(props: IMessageTotalsByMonthTableProps) {
        super(props);
    }

    public render() {
        if (this.props.messageTotals === null || this.props.messageTotals.length === 0) {
            return null;
        }

        return (
            <table className="table table-sm">
                <thead className="thead-light">
                    <tr>
                        {this.renderHeaderColumns(this.props.messageTotals[0])}
                    </tr>
                </thead>
                <tbody>
                    {this.renderBodyRows(this.props.messageTotals)}
                </tbody>
            </table>
        );
    }

    private renderHeaderColumns(messageTotal: IMessageTotalsByMonthResponse) {
        const headerColumns: React.ReactNode[] = [];

        headerColumns.push(<th key="month">{this.props.t("MessageTotalsByMonthTable.MonthLabel")}</th>);
        messageTotal.channels.forEach(channel => {
            headerColumns.push(<th style={{textAlign: "right"}} key={channel.channel}>{channel.channel}</th>);
        });

        return headerColumns;
    }

    private renderBodyRows(messageTotals: IMessageTotalsByMonthResponse[]) {
        const rows: React.ReactNode[] = [];

        messageTotals.forEach((messageTotal, index) => {
            rows.push(<tr key={index}>{this.renderBodyColumns(messageTotal)}</tr>)
        });

        return rows;
    }

    private renderBodyColumns(messageTotal: IMessageTotalsByMonthResponse) {
        const columns: React.ReactNode[] = [];

        columns.push(<td key="month">{moment(messageTotal.month).format("MMM, YYYY")}</td>);
        messageTotal.channels.forEach(channel => {
            columns.push(<td style={{textAlign: "right"}} key={channel.channel}>{channel.numberOfMessages}</td>);
        });

        return columns;
    }
    
}

export default translateComponent(MessageTotalsByMonthTable);



// WEBPACK FOOTER //
// ./src/components/Dashboard/MessageTotalsByMonthTable.tsx